import { ActionManagementModel } from "../models/action-management.model";
import { ActionModel, FindingModel } from "../models/assesment.model";

import { createAction } from "@ngrx/store";

export const ADD_ACTIONMANAGEMENT = createAction(
  "ADD_ACTIONMANAGEMENT",
  (data: ActionManagementModel) => data,
);

export const UPDATE_ACTIONMANAGEMENT = createAction(
  "UPDATE_ACTIONMANAGEMENT",
  (data: FindingModel | ActionModel, entityType: "finding" | "action") => ({
    data,
    entityType,
  }),
);

export const REMOVE_ACTIONMANAGEMENT = createAction(
  "REMOVE_ACTIONMANAGEMENT",
  (id: string, assessmentId: string, entityType: "finding" | "action") => ({
    id,
    assessmentId,
    entityType,
  }),
);
